export var REQUIRED = 'This field is required';
export var INVALID_EMAIL = 'Invalid email address';
export var ONLY_ALPHA_NUMERIC = 'Only alphanumeric characters';
export var MAX_3_DIGITS = 'Max 3 digits after decimal point';
export var NOT_ZERO = 'Not zero';
export var INVALID_PHONE_10_DIGITS = 'Invalid phone number, must be 10 digits';
export var INVALID_PHONE = 'Invalid phone number';
export var INVALID_PHONE_NUMBER = 'Invalid phone number, check your number/country zone';
export var START_DATE_REQUIRED = 'Start date is required';
export var END_DATE_REQUIRED = 'End date is required';
export var maxLengthMessage = function maxLengthMessage(max) {
  return "Must be ".concat(max, " characters or less");
};
export var minLengthMessage = function minLengthMessage(min) {
  return "Must be ".concat(min, " characters or more");
};
export var minMessage = function minMessage(minVal) {
  return "Must be at least ".concat(minVal);
};
export var maxMessage = function maxMessage(maxVal) {
  return "Must be at most ".concat(maxVal);
};
export var moreThanMessage = function moreThanMessage(value) {
  return "Must be more than ".concat(value);
};
export var lessThanMessage = function lessThanMessage(value) {
  return "Must be less than ".concat(value);
};